import React from "react";
import { Card, Typography } from "antd";
import Select from "react-select";

class SelectInputComponent extends React.Component {
  handleChange = value => {
    const { setFieldValue, name } = this.props;
    setFieldValue(name, value);
  };

  render() {
    const { defaultValue, options, values, multi, label, name } = this.props;

    return (
      <Card>
        <Typography.Text level={3}>{label}</Typography.Text>
        <Select
          id={name}
          defaultValue={defaultValue}
          options={options}
          isMulti={multi}
          onChange={this.handleChange}
          value={values[name]}
        />
      </Card>
    );
  }
}

export default SelectInputComponent;
